export default __webpack_public_path__ + "static/logo14-8baf6349ea8a3115d31090f20ae9aee1.png";